import * as React from "react";
import { connect } from "react-redux";
import { selectCoopProjectType } from "../../../balancingSelectors/selectBalancingCoopProjects";
import { IdStyles } from "../../../less/IdStyles";
import { selectCoopCompletedProject, selectCoopSelectedProjectDifficultyLevel, selectCoopXpBuffFactorForProjectType, } from "../../../selectors/selectCoopInfo";
import { IdLoca } from "../../../utils/i18n/IdLoca";
import { ReplacementLoca } from "../../../utils/i18n/ReplacementLoca";
import { utilLoca } from "../../../utils/i18n/utilLoca";
import { utilCoopProject } from "../../../utils/utilCoopProject";
import { utilNumber } from "../../../utils/utilNumber";
import { DialogWrapper } from "../../dialog/DialogWrapper";
import { ButtonPrimary } from "../../generic/common/ButtonPrimary";
import { TextLoca } from "../../generic/text/TextLoca";
import { actionModalClose } from "../../modals/actionModal";
import { IdModal } from "../../modals/IdModal";
import { actionCoopInfoResetProject } from "../actionCoop";
var _DialogCoopProjectCompleted = function (_a) {
    var completedCoopProjectType = _a.completedCoopProjectType, onClose = _a.onClose, completedCoopProjectXpReward = _a.completedCoopProjectXpReward;
    if (!completedCoopProjectType) {
        return React.createElement(React.Fragment, null);
    }
    var locaReplacements = new Map([
        [ReplacementLoca.zero_0, utilLoca.get(completedCoopProjectType.locakey)],
        [ReplacementLoca.one_1, utilNumber.format(completedCoopProjectXpReward)],
    ]);
    return (React.createElement(DialogWrapper, { titleLocaId: IdLoca.congratulations, onClose: onClose, className: IdStyles.ModalBackgroundResources },
        React.createElement("div", { className: "dialog-coop__confirmation" },
            React.createElement(TextLoca, { className: IdStyles.TextNormal, id: IdLoca.coopProject_successful, replacements: locaReplacements }),
            React.createElement(ButtonPrimary, { onClick: onClose },
                React.createElement(TextLoca, { className: IdStyles.TextButtonDefault, id: IdLoca.hooray })))));
};
var mapState = function (state) {
    var completedCoopProject = selectCoopCompletedProject(state);
    var completedCoopProjectType;
    var completedCoopProjectXpReward = 0;
    if (completedCoopProject) {
        completedCoopProjectType = selectCoopProjectType(completedCoopProject.typeId);
        var selectedCoopProjectDifficultyLevel = selectCoopSelectedProjectDifficultyLevel(state);
        if (completedCoopProjectType) {
            var completedCoopProjectDifficulty = utilCoopProject.getProjectDifficultyLevelType(completedCoopProjectType, selectedCoopProjectDifficultyLevel);
            var buffFactor = selectCoopXpBuffFactorForProjectType(state, completedCoopProjectType);
            completedCoopProjectXpReward = completedCoopProjectDifficulty.coopXpReward * buffFactor;
        }
    }
    return {
        completedCoopProjectType: completedCoopProjectType,
        completedCoopProjectXpReward: completedCoopProjectXpReward,
    };
};
var mapDispatch = function (dispatch) { return ({
    onClose: function () {
        dispatch(actionCoopInfoResetProject());
        dispatch(actionModalClose(IdModal.CoopProjectCompleted));
    },
}); };
export var DialogCoopProjectCompleted = connect(mapState, mapDispatch)(_DialogCoopProjectCompleted);



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/projects/DialogCoopProjectCompleted.tsx
// module id = 2810
// module chunks = 3